// IA-1 (ajuste 2): dominio para la vista previa de Google del SEO en la ficha. Usa el dominio
// REAL de la tienda (de la config, GET /api/config → tienda.dominio); si no llegó, cae al slug del
// nombre + «.com» como último recurso (el comportamiento viejo, que mostraba «shopping-hunters.com»
// en vez de «shoppinghunters.co»). Puro y testeable.
export function dominioParaPreview(dominioConfig, nombreTienda) {
  const d = String(dominioConfig || '').trim().replace(/^https?:\/\//, '').replace(/\/+$/, '');
  if (d) return d;
  const slug = String(nombreTienda || '')
    .toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return `${slug || 'mi-tienda'}.com`;
}
